// TODO: create new modal with portal and encapsulated controls
import { cn } from '@global/utils/tailwind'

export const Modal = ({ children, onClose, className = '' }) => {
  const handleCloseModal = () => {
    onClose?.()
  }

  const handleContentClick = event => {
    event.stopPropagation()
  }

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]"
      onClick={handleCloseModal}
    >
      <div className={cn('bg-white shadow-lg py-14 px-12', className)} onClick={handleContentClick}>
        {children}
      </div>
    </div>
  )
}

const Header = ({ children, className = '' }) => (
  <div className={cn('flex font-sans font-bold text-xl', className)}>{children}</div>
)

const Footer = ({ children, className = '' }) => (
  <div className={cn('flex justify-between mt-4', className)}>{children}</div>
)

Modal.Header = Header
Modal.Footer = Footer
